"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _store = _interopRequireDefault(require("../store/store"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

var _UpdateNotificationsService = _interopRequireDefault(require("../service/UpdateNotificationsService"));

var _PulseApiHelper = _interopRequireDefault(require("../service/PulseApiHelper"));

var NotificationsSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var instance;

function metrics() {
  return instance || (instance = _metrics.default.create("exc.pulse.actions.Reminders"));
}

var Reminders =
/*#__PURE__*/
function () {
  function Reminders(props) {
    (0, _classCallCheck2.default)(this, Reminders);
  }

  (0, _createClass2.default)(Reminders, [{
    key: "setReminder",
    value: function () {
      var _setReminder = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(notificationId, reminderInMillsecs) {
        var timeOnServer, pulseApiHelper, notification, ansNotification, p;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                timeOnServer = NotificationsSelectors.getServerTime(_store.default.getState());
                pulseApiHelper = new _PulseApiHelper.default();
                _context2.next = 4;
                return _store.default.dispatch({
                  type: types.SET_REMINDER_ON_NOTIFICATION,
                  payload: {
                    id: notificationId,
                    reminderTime: timeOnServer + reminderInMillsecs
                  }
                });

              case 4:
                notification = NotificationsSelectors.getNotificationById(_store.default.getState(), notificationId);
                ansNotification = pulseApiHelper.createANSFormatForReminders(notification); // call backend

                p = new _UpdateNotificationsService.default().updateNotifications([ansNotification]);
                p.then(
                /*#__PURE__*/
                function () {
                  var _ref = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee(data) {
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(data.notification.length <= 0)) {
                              _context.next = 5;
                              break;
                            }

                            _context.next = 3;
                            return _store.default.dispatch({
                              type: types.REMOVE_REMINDER_ON_NOTIFICATION,
                              payload: {
                                id: notificationId
                              }
                            });

                          case 3:
                            _context.next = 7;
                            break;

                          case 5:
                            metrics().event("reminder.set.success", {
                              region: window.config && window.config.region
                            });
                            console.log('Setting reminder SUCCESS!');

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function setReminder(_x, _x2) {
        return _setReminder.apply(this, arguments);
      }

      return setReminder;
    }()
  }, {
    key: "removeReminders",
    value: function () {
      var _removeReminders = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(ids) {
        var pulseApiHelper;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                pulseApiHelper = new _PulseApiHelper.default();
                _context5.next = 3;
                return ids.map(
                /*#__PURE__*/
                function () {
                  var _ref2 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee4(entry) {
                    var ansNotification, p;
                    return _regenerator.default.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _store.default.dispatch({
                              type: types.REMOVE_REMINDER_ON_NOTIFICATION,
                              payload: {
                                id: entry.id
                              }
                            });

                          case 2:
                            ansNotification = pulseApiHelper.createANSFormatForClearReminders(entry); // call backend

                            p = new _UpdateNotificationsService.default().updateNotifications([ansNotification]);
                            p.then(
                            /*#__PURE__*/
                            function () {
                              var _ref3 = (0, _asyncToGenerator2.default)(
                              /*#__PURE__*/
                              _regenerator.default.mark(function _callee3(data) {
                                return _regenerator.default.wrap(function _callee3$(_context3) {
                                  while (1) {
                                    switch (_context3.prev = _context3.next) {
                                      case 0:
                                        if (data.notification.length < 0) {
                                          //TODO: how to handle failure in removing
                                          console.log('Removing reminder FAILED!');
                                        } else {
                                          metrics().event("reminder.removed", {
                                            region: window.config && window.config.region
                                          });
                                          console.log('Removing reminder SUCCESS!');
                                        }

                                      case 1:
                                      case "end":
                                        return _context3.stop();
                                    }
                                  }
                                }, _callee3);
                              }));

                              return function (_x6) {
                                return _ref3.apply(this, arguments);
                              };
                            }());

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function removeReminders(_x4) {
        return _removeReminders.apply(this, arguments);
      }

      return removeReminders;
    }()
  }]);
  return Reminders;
}();

var _default = new Reminders();

exports.default = _default;